import React, { useEffect, useState } from "react";
import { ReactComponent as Facebook } from "../../assets/SvgFiles/facebook.svg";
import { ReactComponent as Instagram } from "../../assets/SvgFiles/instagram.svg";
import { ReactComponent as Twitter } from "../../assets/SvgFiles/twitter.svg";
import { ReactComponent as Linkedin } from "../../assets/SvgFiles/linkedin.svg";
import { ReactComponent as Home } from "../../assets/SvgFiles/home.svg";
import { ReactComponent as SelectedHome } from "../../assets/SvgFiles/selected-home.svg";
import { ReactComponent as SelectedChat } from "../../assets/SvgFiles/selected-Chat.svg";
import { ReactComponent as SelectedSave } from "../../assets/SvgFiles/selected-saved.svg";
import { ReactComponent as SelectedProfile } from "../../assets/SvgFiles/selected-profile.svg";
import { ReactComponent as Chat } from "../../assets/SvgFiles/chat.svg";
import { ReactComponent as Save } from "../../assets/SvgFiles/save.svg";
import { ReactComponent as Profile } from "../../assets/SvgFiles/profile.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Footer2 = () => {


  const navigate = useNavigate();

 

 
  const { t, i18n } = useTranslation();  // Get translation function 't' and i18n instance

  const [active, setActive] = useState("home");
  const [language, setLanguage] = useState("en");

  const tabs = [
    { name: "home", icon: <Home />, selected: <SelectedHome />, path: "/dashboard" },
    { name: "post", icon: <Save />, selected: <SelectedSave />, path: "/dashboard/createlist" },
    { name: "profile", icon: <Profile />, selected: <SelectedProfile />, path: "/dashboard/profile" },
  ];


  const handleClick = (tab) => {
    setActive(tab.name);
    navigate(tab.path);
  };

  const handleSignup = () => {
    navigate("/signup", { state: { isAgent: true } });
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || "en";
    i18n.changeLanguage(savedLanguage);
    setLanguage(savedLanguage);
  }, []);



  return (
  <footer className="w-full">
  <div className="fixed inset-x-0 bottom-0 z-50 lg:hidden bg-gray-800 text-white h-[70px] shadow-lg px-3 pb-[env(safe-area-inset-bottom)]">
    <nav className="flex items-center justify-evenly h-full">
      {tabs.map((tab) => {
        const isActive = active === tab.name;
        return (
          <button
            key={tab.name}
            onClick={() => handleClick(tab)}
            className="flex flex-col items-center justify-center gap-1"
            aria-label={tab.name}
          >
            <span className={`w-6 h-6 flex items-center justify-center ${isActive ? "text-[#F06565]" : "text-white"}`}>
              {isActive ? tab.selected : tab.icon}
            </span>
            <span className={`text-[12px] ${isActive ? "text-[#F06565]" : "text-white"}`}>
              {tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}
            </span>
          </button>
        );
      })}
    </nav>
  </div>
</footer>






  );
};

export default Footer2;
